<template>
    <section id="form_section">
        <div class="container">
            <div class="service_header">
                <h1 class="service_title">Калькулятор терміну окупності пристрою КРП з CVR</h1>
                <div>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
                <div class="contact" v-if="phone">
                    <p>Консультації за телефоном:</p>
                    <a :href="'tel:'+phone">{{ phone }}</a>
                </div>
                </div>
            </div>


            <div class="top_panel">
                <div class="tabs">
                    <div class="content_tab content_tab-item" v-for="(tab, i) in tabs" :key="`tab_${i}`" :class="{'active': activeTab === i}" @click.prevent="selectTab(i)">
                        <span>{{ tab.title }}</span>
                        <a href="#" class="delete_icon" v-tooltip.bottom.focus="'Видалити проект'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" @click.prevent="deleteTab(i)">
                                <path d="M4.26671 12.6666L3.33337 11.7333L7.06671 7.99998L3.33337 4.26665L4.26671 3.33331L8.00004 7.06665L11.7334 3.33331L12.6667 4.26665L8.93337 7.99998L12.6667 11.7333L11.7334 12.6666L8.00004 8.93331L4.26671 12.6666Z" fill="#B70D09"/>
                            </svg>
                        </a>
                    </div>
                    <div class="content_tab disabled" @click.prevent="addTab()">
                        <span>+ Додати проект</span>
                    </div>
                </div>
                <div v-tooltip.bottom.focus="'Ви можете додати до 10 проектів'" tabindex="1">
                    <svg id="tooltip1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_7547_1269)">
                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_7547_1269">
                            <rect width="16" height="16" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>

            <div class="tab_content" v-if="tabs[activeTab]">
                <div class="tab_content_item left">
                    <div class="project_name">
                        <span class="project_name_editable" v-if="!editTitle" @click="() => {editTitle = true; tabs[activeTab].oldTitle = tabs[activeTab].title}">{{ tabs[activeTab].title }}</span>
                        <div class="edit_title_container" v-else>
                            <input class="edit_title_input" type="text" maxlength="20" v-model="tabs[activeTab].oldTitle"/>
                            <div class="edit_title_container_btns">
                                <a href="#" class="save_title_btn" @click.prevent="() => {tabs[activeTab].title = tabs[activeTab].oldTitle.length ? tabs[activeTab].oldTitle : tabs[activeTab].title; editTitle = false }">Зберегти</a>
                                <a href="#" class="cancel_title_btn" @click.prevent="() => { tabs[activeTab].oldTitle = tabs[activeTab].title; editTitle = false }">Скасувати</a>
                            </div>
                        </div>
                    </div>
                    <p class="project_name_subtitle">Вказані типові значення, підставте свої для необхідних обчислень</p>
                    <div class="input_groups">
                        <div class="input_group">
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Споживання активної енергії, P <br> кВт*год/міс.</span>
                                <div class="input_row">
                                    <input class="form_input" type="number" min="0" v-on:input="changeValue()" v-model="tabs[activeTab].var1">
                                    <div tabindex="1" v-tooltip.bottom.focus="'Сумарне споживання активної енергії кВт*год. На місяць'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Максимальне споживання <br> реактивної потужності, <br> Q max кВАр*год</span>
                                <div class="input_row">
                                    <input class="form_input" type="number" min="0" v-on:input="changeValue()" v-model="tabs[activeTab].var3">
                                    <div tabindex="1" v-tooltip.bottom.focus="'Максимальне зафіксоване значення годинного споживання реактивної енергії кВАр*год. за місяць. Показник впливає на потужність пропонованого ПКРП'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Середнє значення лінійної <br> напруги в мережі, В</span>
                                <div class="input_row">
                                    <input class="form_input" type="number" min="0" v-on:input="changeValue()" v-model="tabs[activeTab].var5">
                                    <div tabindex="1" v-tooltip.bottom.focus="'Середнє значення лінійної напруги в мережі за місяць. Показник впливає на додаткове енергозбереження за рахунок зниження напруги'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Вартість активної потужності, P <br> грн. за кВт*год</span>
                                <div class="input_row">
                                    <input class="form_input" type="number" min="0" v-on:input="changeValue()" v-model="tabs[activeTab].var7">
                                    <div tabindex="1" v-tooltip.bottom.focus="'Зведена вартість кВт*год активної потужності для підприємства. Показник впливає на розрахунок економії, та термін окупності обладнання.'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Вартість реактивної потужності, Q <br> грн. за кВАр*год</span>
                                <div class="input_row">
                                    <input class="form_input" type="number" min="0" v-on:input="changeValue()" v-model="tabs[activeTab].var9">
                                    <div tabindex="1" v-tooltip.bottom.focus="'Зведена вартість кВАр*год споживання реактивної потужності для підприємства. Показник впливає на розрахунок економії, та термін окупності обладнання.'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input_group">
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Споживання реактивної <br> енергії, Q кВАр*год/міс.</span>
                                <div class="input_row">
                                    <input class="form_input" type="number" min="0" v-on:input="changeValue()" v-model="tabs[activeTab].var2">
                                    <div tabindex="1" v-tooltip.bottom.focus="'Сумарне споживання реактивної енергії кВАр*год. На місяць'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Потужність силового <br> трансформатора, S кВА</span>
                                <div class="input_row">
                                    <select class="nominal_select" v-model="tabs[activeTab].var4" v-on:change="changeValue()">
                                        <option :value="null" disabled>Вибрати</option>
                                        <option v-for="(n, i) in transValues" :key="`value_${i}`" :value="n">{{ n }}</option>
                                    </select>

                                    <div tabindex="1" v-tooltip.bottom.focus="'Потужність трансформатору, кВА. Показник впливає на, рівень напруги після компенсації.'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Положення перемикача на <br> стороні ВН трансформатора, %</span>
                                <div class="input_row">
                                    <select class="nominal_select" v-model="tabs[activeTab].var6" v-on:change="changeValue()">
                                        <option :value="null" disabled>Вибрати</option>
                                        <option v-for="(n, i) in polozenie" :key="`value_${i}`" :value="n">{{ n }} %</option>
                                    </select>
                                    <div tabindex="1" v-tooltip.bottom.focus="'Існуюче положення перемикача відгалужень обмоток ВН трансформатора. Показник впливає на можливий діапазон зміни напруги.'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Зниження напруги для <br> розрахунку, %</span>
                                <div class="input_row">
                                    <select class="nominal_select" v-model="tabs[activeTab].var8" v-on:change="changeValue()">
                                        <option :value="null" disabled>Вибрати</option>
                                        <option v-for="(n, i) in snizenie" :key="`value_${i}`" :value="n">{{ n }} %</option>
                                    </select>
                                    <div tabindex="1" v-tooltip.bottom.focus="'Пропоноване у % значення зниження напруги для розрахунку. Показник впливає на рівень напруги після компенсації, та рівень економії і термін окупності.'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Положення перемикача на стороні ВН <br> трансформатора після регулювання, %</span>
                                <div class="input_row">

                                    <div class="row_block">
                                        <input class="form_input var10" :class="{'warning': var10WarningMsg}" type="number" disabled v-model="tabs[activeTab].var10">
                                        <span class="warning_text var10" v-if="var10WarningMsg">Значення неможливо, враховуючи первинне положення перемикача</span>
                                        <span class="warning_text" v-else>&nbsp;</span>
                                    </div>

                                    <div tabindex="1" v-tooltip.bottom.focus="'Положення перемикача відгалужень обмоток ВН трансформатора після зниження напруги у %.Показник використовується для перевірки можливості зниження напруги на запропоновану величину(Можливий діапазон від +5% до -5%, та розуміння положення перемикача після зниження напруги.'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab_content_item">
                    <div class="project_name">
                        Економія енергії, на місяць
                    </div>
                    <p class="project_name_subtitle">Після встановлення пристрою компенсації</p>

                    <div class="graphic_block input_groups">
                        <div class="graphic">
                            <Pie ref="primeChart" :data="chartData" :options="chartOptions" />
                        </div>
                        <div class="info_block">
                            <div class="graphic_info">
                                <div class="graphic_info_row">
                                    <p class="graphic_info_title">Вартість КРП, EUR</p>
                                    <p class="graphic_info_title_bold" v-if="!tabs[activeTab].isCalculationDisabled">{{ number_format( tabs[activeTab].res7, 2, ',', ' ' ) }}</p>
                                </div>
                                <div class="graphic_info_row">
                                    <p class="graphic_info_title">Економія, EUR/міс.</p>
                                    <p class="graphic_info_title_bold" v-if="!tabs[activeTab].isCalculationDisabled">{{ number_format( tabs[activeTab].res8 + tabs[activeTab].res9, 2, ',', ' ' ) }}</p>
                                </div>
                            </div>
                            <div class="graphic_info_row">
                                <p class="graphic_info_title_bold">Термін окупності</p>
                                <p class="graphic_info_title_bold" v-if="!tabs[activeTab].isCalculationDisabled">{{ number_format( tabs[activeTab].res10, 2, ',', ' ' ) }} міс</p>
                            </div>
                            <a class="view_spec_btn summ_btn" v-if="tabs[activeTab].isCalculationDisabled" v-on:click="doSummarize()">Розрахувати</a>
                        </div>
                    </div>

                    <div class="project_name">
                        Результат обчислень
                    </div>
                    <div class="result_list">
                        <template v-if="!tabs[activeTab].isCalculationDisabled">
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовне середнє значення лінійної напруги в мережі з урахуванням компенсації реактивної потужності'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Середнє значення лінійної напруги в мережі після встановлення КРП, В
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res1, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Рекомендований мінімальний рівень лінійної напруги'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Рекомендований рівень лінійної напруги в мережі, В
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res2, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Рекомендована потужність пристрою компенсації кВАр, приймається для розрахунку терміну окупності ПКРП'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Рекомендована потужність пристрою компенсації, кВАр
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res3, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="row_block">
                                <div class="graphic_info_title">
                                    <div tabindex="1" v-tooltip.right.focus="'Середнє значення напруги в мережі після зниження, В, для перевірки, чи не менше рекомендованого значення'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_7547_1269)">
                                                <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7547_1269">
                                                <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    Середнє значення напруги в мережі після зниження, В
                                </div>
                                <span class="warning_text" v-if="res4WarningMsg">Значення напруги менше рекомендованої</span>
                                <span class="warning_text" v-else>&nbsp;</span>
                            </div>
                            <p class="graphic_info_title_bold price_row" :class="{'warning': res4WarningMsg}">{{ number_format( tabs[activeTab].res4, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовне значення економії активної потужності кВт за годину за рахунок зниження напруги(CVR)'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Економія активної потужності, кВт/год
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res5, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовне значення зменшення споживання реактивної потужності кВАр за годину за рахунок роботи пристрою компенсації реактивної потужності'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Економія реактивної потужності, кВАр/год
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res6, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовна вартість пристрою компенсації реактивної потужності, євро з ПДВ'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Орієнтовна вартість швидкодіючої ПКРП <br> з дроселями 189 Гц, євро з ПДВ
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res7, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовна економія активної потужності в євро за місяць, з ПДВ'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                Економія активної потужності в євро з ПДВ за місяць
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res8, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовна економія реактивної потужності в євро за місяць, з ПДВ'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                               Економія реактивної потужності в євро з ПДВ за місяць
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res9, 2, ',', ' ' ) }}</p>
                        </div>
                        <div class="graphic_info_row">
                            <div class="graphic_info_title">
                                <div tabindex="1" v-tooltip.right.focus="'Орієнтовний термін окупності ПКРП, місяців'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                               Термін окупності КРП, місяців
                            </div>
                            <p class="graphic_info_title_bold price_row">{{ number_format( tabs[activeTab].res10, 2, ',', ' ' ) }}</p>
                        </div>
                        </template>
                    </div>
                    <a class="view_spec_btn" v-on:click="getExcel()" v-if="!tabs[activeTab].isCalculationDisabled">Завантажити в Excel</a>
                    <a class="view_spec_btn disabled" disabled v-else>Завантажити в Excel</a>
                </div>
            </div>

        </div>


        <div class="overlay" v-if="modal_info || modal_confirm" v-on:click="closeModals"></div>
        
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>

        <div class="modal description_modal modal_confirm" v-if="modal_confirm && activeTab >= 0">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Ви хочете видалити</p>
                    <svg id="close_modal" v-on:click="modal_confirm = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content">{{ tabs[activeTab].title }}?</div>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_confirm" @click.prevent="modal_confirm=false">Відмінити</a>
                    <a href="#" class="confirm_button_cancel" @click.prevent="deleteTab(activeTab)">Видалити</a>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import Chart from "primevue/chart";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Tooltip from 'primevue/tooltip';
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { Pie } from 'vue-chartjs';

ChartJS.register(ArcElement, ChartTooltip, Legend, ChartJSPluginDatalabels);

export default {
    directives: {
        Tooltip,
    },
    props: {
        text: {
            type: String,
            required: false,
        },
        default: {
            type: Number,
            required: false,
        },
        widget: {
            required: false,
        },
        phone: {
            required: false,
        },
    },
    components: {
        Pie,
    },
    layout: CommonLayout,

    data() {
        return {
            tabs: [
                {
                    title: 'Новий проект',
                    var1: 480000, //Споживання активної енергії, кВт*год/міс.
                    var2: 240000, //Споживання реактивної енергії, кВАр*год/міс.
                    var3: 500, //Максимальне споживання реактивної потужності, кВАр*год
                    var4: 1600, //Потужність силового трансформатора, кВА
                    var5: 415, //Середнє значення лінійної напруги в мережі, В
                    var6: 2.5, //Положення перемикача на стороні ВН трансформатора, %
                    var7: 5, //Вартість активної потужності P, грн. за кВт*год
                    var8: 5, //Зниження напруги для розрахунку, %
                    var9: 0.1, //Вартість реактивної потужності P, грн. за кВт*год
                    var10: -2.5, //Положення перемикача на стороні ВН трансформатора після регулювання, %

                    res1: null, //Середнє значення лінійної напруги в мережі після встановлення КУ, В
                    res2: null, //Рекомендований рівень лінійної напруги в мережі, В
                    res3: null, //Рекомендована потужність пристрою компенсації, кВАр
                    res4: null, //Середнє значення напруги в мережі після зниження, В
                    res5: null, //Економія активної потужності, кВт/год
                    res6: null, //Економія реактивної потужності, кВАр/год
                    res7: null, //Орієнтовна вартість швидкодіючої ПКРП з дроселями 189 Гц, євро з ПДВ
                    res8: null, //Економія активної потужності в євро з ПДВ за місяць
                    res9: null, //Економія реактивної потужності в євро з ПДВ за місяць
                    res10: null, //Термін окупності ПКРП , місяців

                    isCalculationDisabled: false
                },
            ],
            activeTab: 0,
            modal_info: false,
            editTitle: false,
            transValues: [ //Потужність трансформатору, кВА
                250,
                315,
                400,
                500,
                630,
                800,
                1000,
                1250,
                1600,
                2000,
                2500,
                3150
            ],
            polozenie: [ //Положення перемикача на стороні ВН трансформатора
                5,
                2.5,
                0,
                -2.5,
                -5
            ],
            snizenie: [ //Зниження напруги для розрахунку,%
                0,
                2.5,
                5,
                7.5,
                10
            ],

            chartData: {},
            chartOptions: {},
            res4WarningMsg: false,
            var10WarningMsg: false,
            modal_confirm: false,
        }
    },

    created() {
        this.calculation();
    },

    mounted() {
        this.$nextTick(function () {
            this.chartData = this.setChartData();
            this.chartOptions = this.setChartOptions();

            if (this.widget) {
                let script = document.createElement("script");

                // Add script content
                script.innerHTML = this.widget;

                // Append
                document.head.appendChild(script);
            }
        })
    },

    methods: {
        addTab() {
            if (this.tabs.length <= 9) {
                this.tabs.push({
                    title: 'Новий проект ' + this.tabs.length,
                    var1: 480000, //Споживання активної енергії, кВт*год/міс.
                    var2: 240000, //Споживання реактивної енергії, кВАр*год/міс.
                    var3: 500, //Максимальне споживання реактивної потужності, кВАр*год
                    var4: 1600, //Потужність силового трансформатора, кВА
                    var5: 415, //Середнє значення лінійної напруги в мережі, В
                    var6: 2.5, //Положення перемикача на стороні ВН трансформатора, %
                    var7: 5, //Вартість активної потужності P, грн. за кВт*год
                    var8: 5, //Зниження напруги для розрахунку, %
                    var9: 0.1, //Вартість реактивної потужності P, грн. за кВт*год
                    var10: -2.5, //Положення перемикача на стороні ВН трансформатора після регулювання, %

                    res1: null, //Середнє значення лінійної напруги в мережі після встановлення КУ, В
                    res2: null, //Рекомендований рівень лінійної напруги в мережі, В
                    res3: null, //Рекомендована потужність пристрою компенсації, кВАр
                    res4: null, //Середнє значення напруги в мережі після зниження, В
                    res5: null, //Економія активної потужності, кВт/год
                    res6: null, //Економія реактивної потужності, кВАр/год
                    res7: null, //Орієнтовна вартість швидкодіючої ПКРП з дроселями 189 Гц, євро з ПДВ
                    res8: null, //Економія активної потужності в євро з ПДВ за місяць
                    res9: null, //Економія реактивної потужності в євро з ПДВ за місяць
                    res10: null, //Термін окупності ПКРП , місяців

                    isCalculationDisabled: false
                });

                this.activeTab = this.tabs.length - 1

                this.calculation();
            }
        },
        deleteTab(i) {
            if (this.modal_confirm) {
                this.tabs.splice(i, 1);

                this.modal_confirm = false

                this.activeTab = this.tabs.length - 1
            } else {
                this.modal_confirm = true;
            }
        },

        closeModals() {
            this.modal_info = false;
            this.modal_confirm = false;
        },

        selectTab(i) {
            this.editTitle = false;
            this.activeTab = i;

            this.calculation();
        },

        changeValue() {
            this.tabs[this.activeTab].isCalculationDisabled = true
            this.chartData = this.setChartData();
            this.chartOptions = this.setChartOptions();
            // this.calculation();
        },

        doSummarize() {
            this.tabs[this.activeTab].isCalculationDisabled = false
            this.calculation();
        },

        calculation() {
            this.res4WarningMsg = false

            this.var10WarningMsg = false

            // var1: 480000, //Споживання активної енергії, кВт*год/міс.
            // var2: 240000, //Споживання реактивної енергії, кВАр*год/міс.
            // var3: 500, //Максимальне споживання реактивної потужності, кВАр*год
            // var4: 1600, //Потужність силового трансформатора, кВА
            // var5: 415, //Середнє значення лінійної напруги в мережі, В
            // var6: 2.5, //Положення перемикача на стороні ВН трансформатора, %
            // var7: 5, //Вартість активної потужності P, грн. за кВт*год
            // var8: 5, //Зниження напруги для розрахунку, %
            // var9: 0.1, //Вартість реактивної потужності P, грн. за кВт*год
            // var10: -2.5, //Положення перемикача на стороні ВН трансформатора після регулювання, %

            // res1: null, //Середнє значення лінійної напруги в мережі після встановлення КУ, В
            // res2: null, //Рекомендований рівень лінійної напруги в мережі, В
            // res3: null, //Рекомендована потужність пристрою компенсації, кВАр
            // res4: null, //Середнє значення напруги в мережі після зниження, В
            // res5: null, //Економія активної потужності, кВт/год
            // res6: null, //Економія реактивної потужності, кВАр/год
            // res7: null, //Орієнтовна вартість швидкодіючої ПКРП з дроселями 189 Гц, євро з ПДВ
            // res8: null, //Економія активної потужності в євро з ПДВ за місяць
            // res9: null, //Економія реактивної потужності в євро з ПДВ за місяць
            // res10: null, //Термін окупності ПКРП , місяців

            if (this.tabs[this.activeTab]) {

                // Потужність трансформатору, кВА => Вплив на напругу 100 кВАр,%
                const relations = {
                    250: 2.36,
                    315: 1.873,
                    400: 1.475,
                    500: 1.180,
                    630: 0.937,
                    800: 0.738,
                    1000: 0.590,
                    1250: 0.472,
                    1600: 0.369,
                    2000: 0.295,
                    2500: 0.236,
                    3150: 0.187,
                };

                // res1  = Середнє значення лінійної напруги в мережі після встановлення КУ, В

                let const1 = this.tabs[this.activeTab].var2 / 30 / 24;
                let const2 = relations[this.tabs[this.activeTab].var4]
                let res1 = this.tabs[this.activeTab].var5  * ( 1 + ( (const1 / 100) * (const2 / 100) ) )

                this.tabs[this.activeTab].res1 = res1

                // res2 = Рекомендований рівень лінійної напруги в мережі, В
                let res2 = 390.00;
                this.tabs[this.activeTab].res2 = res2;

                // res3 = Рекомендована потужність пристрою компенсації, кВАр
                let const3 = this.tabs[this.activeTab].var3;
                let res3 = const3 * 1.2;
                this.tabs[this.activeTab].res3 = res3

                // res4 = Середнє значення напруги в мережі після зниження, В
                let const4 = this.tabs[this.activeTab].var8;
                let res4 = res1 * (100 - const4) / 100;
                this.tabs[this.activeTab].res4 = res4

                if (res4 < 390) {
                    this.res4WarningMsg = true
                }

                // res5 = Економія активної потужності, кВт/год
                let e5 = this.tabs[this.activeTab].var1 / 30 / 24;
                let const6 = 1 - res4 / this.tabs[this.activeTab].var5;

                let const7 = 0.8 * const6;
                let res5 = e5 * const7;
                this.tabs[this.activeTab].res5 = res5

                // res6 = Економія реактивної потужності, кВАр/год
                let res6 = const1 * 0.98;
                this.tabs[this.activeTab].res6 = res6

                // res7 = Орієнтовна вартість швидкодіючої ПКРП з дроселями 189 Гц, євро з ПДВ
                let j5 = this.tabs[this.activeTab].var3 * 1.2;
                let res7 = j5 * this.default;
                this.tabs[this.activeTab].res7 = res7


                //Економія активної потужності в євро з ПДВ за місяць
                let c15 = res5 * this.tabs[this.activeTab].var7;
                let g5 = this.tabs[this.activeTab].var2 / 30 / 24;
                let b19 = g5 * 0.98;
                let c19 = b19 * this.tabs[this.activeTab].var9;

                let e15 = (c15+c19)/40*24*365/12;
                let e19 = c19/40*24*365/12;

                let res8 = e15 - e19;
                this.tabs[this.activeTab].res8 = res8

                //Економія реактивної потужності в євро з ПДВ за місяць
                let res9 = c19/40*24*365/12;
                this.tabs[this.activeTab].res9 = res9;

                //Термін окупності ПКРП , місяців
                let g15 = j5 * this.default;
                let res10 = g15 / e15;
                this.tabs[this.activeTab].res10 = res10

                this.tabs[this.activeTab].var10 = this.tabs[this.activeTab].var6 - this.tabs[this.activeTab].var8;

                if (this.tabs[this.activeTab].var8 === 2.5 && this.tabs[this.activeTab].var6 === -5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 5 && this.tabs[this.activeTab].var6 === -2.5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 5 && this.tabs[this.activeTab].var6 === -5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 7.5 && this.tabs[this.activeTab].var6 === 0) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 7.5 && this.tabs[this.activeTab].var6 === -2.5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 7.5 && this.tabs[this.activeTab].var6 === -5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 10 && this.tabs[this.activeTab].var6 === 2.5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 10 && this.tabs[this.activeTab].var6 === 0) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 10 && this.tabs[this.activeTab].var6 === -2.5) {
                    this.var10WarningMsg = true
                }

                if (this.tabs[this.activeTab].var8 === 10 && this.tabs[this.activeTab].var6 === -5) {
                    this.var10WarningMsg = true
                }


                this.chartData = this.setChartData();
                this.chartOptions = this.setChartOptions();

                // if (this.$refs.primeChart) {
                //     this.$refs.primeChart.chart.update()
                // }
            }
        },

        number_format(number, decimals, dec_point, thousands_sep) {
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },

        setChartData() {
            // let total = this.tabs[this.activeTab].res9 + this.tabs[this.activeTab].res8;
            // let res9 = ((this.tabs[this.activeTab].res9 / total) * 100).toFixed(1) + '%';
            // let res8 = ((this.tabs[this.activeTab].res8 / total) * 100).toFixed(1) + '%';
            
            return {
                labels: ['Активна', 'Реактивна'],
                datasets: [
                    {
                        data: [
                            this.number_format(this.tabs[this.activeTab].res8, '0', '.', ''),
                            this.number_format(this.tabs[this.activeTab].res9, '0', '.', '')
                        ],
                        backgroundColor: this.tabs[this.activeTab].isCalculationDisabled ? ['#CED4DA', '#E0E3E7'] : ['#356EEF', '#C8E4FF'],
                        hoverBackgroundColor: this.tabs[this.activeTab].isCalculationDisabled ? ['#CED4DA', '#E0E3E7'] : ['#356EEF', '#C8E4FF'],
                    }
                ]
            };
        },

        setChartOptions() {
            if (this.tabs[this.activeTab].isCalculationDisabled) {
                return {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    datalabels: {
                        display: false
                    },
                },
                }
            }
            return {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: '#000'
                        },
                        onClick: null
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                // Access the label and value of the current segment
                                let label = context.formattedValue || '';

                                // Add custom text to the tooltip
                                label += ', євро';

                                return label;
                            },
                        },
                    },
                    datalabels: {
                        formatter: (value) => value + ", євро",
                        display: true,
                        color: function(context) {
                            var index = context.dataIndex;

                            if (index === 0) {
                                return '#FFF'
                            } else {
                                return '#000'
                            }
                        },
                        font: {
                            weight: 'bold',
                            size: 16,
                        },
                    },
                },
            };
        },

        getExcel() {
            axios.post(this.route('api.calculator_get_excel'), {
                tabs: this.tabs,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        }
    }
};
</script>

<style scoped>
a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 25px 0 20px;
}
.service_header {
    display: flex;
    justify-content: space-between;
}
.service_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 651px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

#close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.add_item_modal {
    width: 92%;
}

.add_item_modal .modal_header {
    border-bottom: none;
}

.add_item_modal .modal_header_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

@media (max-width: 780px) {
    .modal {
        width: 100%;
    }
    .container {
        padding: 50px 0 0 0;
    }
    .service_header {
        flex-direction: column;
    }
    .input_groups {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start!important;
    }
    .input_group, .form_input, .nominal_select{
        width: 100%!important;
    }
    .graphic_block {
        align-items: center!important;
    }
    .tabs {
        width: 100vw;
        overflow: auto;
    }
    .content_tab span {
        width: 115px;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 1.2em;
        white-space: nowrap;
    }
    .edit_title_container {
        flex-direction: column;
    }
    .edit_title_input {
        width: auto!important;
    }
    .info_block {
        width: 100%;
    }
}

@media (max-width: 420px) {
    .service_title {
        font-size: 27px;
        line-height: 36px;
    }
}

.top_bar {
    margin-top: 80px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.top_bar .top_bar_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.top_bar .add_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 251px;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
}

.main_table {
    width:100%;
    border-radius: 4px 4px 0px 0px;
}

.main_table, th, td {
  border: 1px solid #DEE2E6;
  border-collapse: collapse;
}

.main_table_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--body-text-body-color, #212529);
    height: 60px;
    background: #E3F1FF;
    overflow-wrap: break-word;
    padding: 5px;
}

.main_table_row {
    height: 53px;
}

.main_table_count_input {
    width: 60px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}

.edit_row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 10px;
}

.total_btns {
    display: flex;
    gap: 26px;
}

.view_spec_btn {
    width: 189px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 12px;
}

.view_spec_btn.disabled {
    background: #DEE2E6;
    color: #6C757D;
}

.download_spec {
    width: 323px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.download_spec.disabled {
    color: #6C757D;
}

.total_summ {
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    gap: 38px;
}

.subtitle {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
}

.form_row {
    display: flex;
    gap: 100px;
}

.input_group {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.form_input_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.form_input_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}

.form_input {
    width: 160px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 10px 16px;
}
.form_select {
    padding: 10px 30px;
    width: 306px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    display: flex;
    align-items: center;
}

.table_select {
    width: 100%;
    padding-left: 10px;
    padding-right: 30px;
    border: none;
    outline: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    cursor: pointer;
}

.form_border {
    border: 1px solid rgba(206, 212, 218, 0.4);
    border-radius: 4px;
    padding: 12px;
    margin-top: 20px;
}

.checkbox_input {
    padding: 0;
    margin: 0;
    margin-right: 9px;
}

.form_border .input_group {
    margin-top: 24px;
}

.line_table {
    margin-top: 30px;
}

.line_table select {
    padding-right: 40px;
}

.line_table thead th {
    height: 72px!important;
}

.line_table tbody tr {
    height: 55px!important;
}

.line_table table {
    table-layout:fixed;
}

.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}


table {
  margin: 0 auto;
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}
table thead th,
table tfoot th {
  text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
table caption {
  padding:.5em;
}
table th,
table td {
    border: 1px solid #DEE2E6;
}

.delete_td {
    padding: 22px 10px 24px 20px;
}

.add_btn {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 16px;
}

.option_select {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    background-color: #FFFFFF;

    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    width: 100%;
}

.count_td {
    padding: 10px 22px 10px 0px;
}

.count_td .count span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}

.count_td .count a {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
}

.count a {
    color: #000000;
}

.ol_num {
    width: 50px;
    text-align: center;
}

.ol_eq {
    width: 288px;
    max-width: 288px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_eq__select {
    width: 240px;
    max-width: 240px;
}

.ol_p_ctn {
    width: 217px;
    max-width: 217px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_p_ctn__select {
    width: 174px;
    max-width: 174px;
}

.ol_char {
    width: 205px;
    max-width: 205px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_char__select {
    width: 166px;
    max-width: 166px;
}

.ol_curr {
    width: 189px;
    max-width: 189px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_curr__select {
    width: 148px;
    max-width: 148px;
}

.ol_cnt {
    width: 128px;
    padding-left: 22px;
}

.ol_article {
    width: 172px;
    max-width: 172px;
    padding-left: 22px;
}

.ol_close {
    width: 46px;
    padding-left: 16px;
}

.summ_point {
    height: 44px;
    text-align: flex-end;
    padding-right: 22px;
}

.summ_value {
    text-align: center;
    padding-right: 22px;
}

.variation_table {
    padding-top: 70px;
}

.variation_table_footer {
    padding-left: 42px;
    padding-right: 42px;
    display: flex;
    justify-content: space-between;
}
.module_ctn_container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.module_ctn {
    display: flex;
    align-items: center;
    gap: 10px;
}
.module_ctn_title {
    margin: 0px;
    padding: 0px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.module_ctn_input {
    width: 86px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}
.btn_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
}
.border-danger {
    border: 1px solid red;
    color: red;
}
.error_text {
    color: red;
}
.modal_total {
    width: 90%;
    top: 435px;
    max-width: 1296px;
}

.modal_total .modal_content{
    overflow: auto;
    height: 470px;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
    margin-bottom: 10px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.bottom_row {
    display: flex;
    width: 100%;
    align-items: flex-end;
    padding-top: 40px;
}

.bottom_row_block {
    display: flex;
    width: 100%;
    align-items: flex-end;
    align-items: baseline;
}

.nominal_select {
    padding: 12px 16px;
    width: 160px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.metal_constr_select {
    width: 260px;
    padding-right: 40px;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 66px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    padding-right: 22px;
    height: 66px;
}
.total_maker {
    width: 62px;
    padding: 0;
    padding-right: 22px;
    height: 66px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_summ2 {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 66px;
}
.center {
    text-align: center;
    height: 66px;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.form_radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.selected_value {
    margin-left: 18px;
    font-weight: 400;
    cursor: pointer;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}

.product_media_modal .modal_content {
    max-height: 70vh;
    margin-top: 0px;
}
.product_media_modal {
    padding: 0px;
    z-index: 10000!important;
}
.product_media_modal #close_modal{
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
}
.warning_popup #close_modal{
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
}

.warning_popup {
    z-index: 100000;
}

.warning_popup h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.warning_popup .confir_btn_group {
    display: flex;
    justify-content: left;
    gap: 15px;
    padding: 10px 0px;
}

.warning_popup .edit_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.warning_popup .confirm_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6C757D;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.block_images {
    display: flex;
    gap: 20px;
}

.sub_images {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 200px;
    overflow: auto;
}

.product_media_modal_sub_images {
    width: 100%;
    display: flex;
    gap: 17px;
    overflow: auto;
    padding: 5px 10px 0px 10px;
    margin-bottom: 10px;
}

.product_img {
    width: 55px;
    height: auto;
    cursor: pointer;
}

.product_media_modal_img {
    width: 48px;
    height: 48px;
    cursor: pointer;
}

.main_img_container {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 180px;
}
.main_img_container svg {
    position: absolute;
    bottom: 8px;
    right: 8px;
    cursor: pointer;
}

.product_info_text {
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    margin-top: 10px;
}

.product-item.active {
    background-color: #C8E4FF;
}
.product_img.active {
    border: 1px solid #C8E4FF;
}
.product_media_modal_img.active {
    border: 1px solid #C8E4FF;
}
.product_video_iframe {
    pointer-events: none;
}

.product_media_modal_main_img {
    width: auto;
    height: auto;
    max-height: 250px;
}

.product_media_modal_description {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.nominal_power, .row_item {
    width: 100%;
}

.product_media_modal_main_img_container {
    position: relative;
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 30px;
}
.product_media_modal_row {
    display: flex;
    gap: 10px;
}
.product_media_modal_main_img_container .group_btns {
    display: flex;
    gap: 30px;
    position: absolute;
    bottom: 20px;
    right: 20px;
}

.zindexed {
    z-index: 9999!important;
}

#addMoadal {
    max-height: 70vh;
}

.input-disabled {
    color: #6C757D!important;
}

.form_input_item_checkbox {
    display: flex;
}

.select_container {
    position: relative;
}

.select_container .clear_icon {
    position: absolute;
    top: 17px;
    right: 35px;
    cursor: pointer;
}

.form_input_title_row {
    display: flex;
    justify-content: space-between;
}

.accountings_type_file_link {
    font-size: 12px;
    color: #356EEF;
    text-decoration: underline;
}

.non_selected {
    color: #6C757D!important;
}

.add_item_modal .info_form {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.graphic_info_title_bold.price_row {
    text-wrap: nowrap;
    white-space: nowrap;
}

@media (max-width: 1120px) {
    .bottom_row {
        align-items: flex-start;
        flex-direction: column;
        gap: 40px;
    }
    .row_item, .bottom_row_block {
        width: auto;
    }
    .bottom_row_block {
        gap: 50px;
    }

    .tab_content {
        flex-direction: column;
    }
}

@media (max-width: 960px) {
    .product_media_modal_main_img {
        width: 100%;
        height: auto;
        max-height: 100%;
    }
    .product_media_modal_row {
        flex-direction: column;
    }
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .add_item_modal .btn_container {
        justify-content: start;
    }
}

@media (max-width: 920px) {
    .main_table_container {
        width: 100%;
        overflow: auto;
    }
    .service_header {
        flex-direction: column;
    }
    .top_bar {
        flex-direction: column;
        justify-content: start;
        align-items: baseline;
    }
    .main_table_title {
        min-width: 120px;
    }

    .add_item_modal .input_group {
        flex-direction: column;
    }

    .add_item_modal .form_row {
        flex-direction: column;
        align-items: center;
    }

    .add_item_modal .info_form {
        width: 100%;
    }

    .add_item_modal .form_input {
        width: 100%;
    }

    .add_item_modal .form_input_item {
        width: 100%;
    }

    .add_item_modal .form_select {
        width: 100%;
    }

    .add_item_modal .line_table {
        overflow: auto;
    }

    .add_item_modal .line_table thead th {
        min-width: 120px;
    }
    .modal_total .modal_bottom {
        flex-direction: column;
        gap: 20px;
    }

    .notification_bar {
        right: 10px!important;
        padding: 20px 20px!important;
        font-size: 12px!important;
    }
}

@media (max-width: 680px) {
    .notification_bar {
        right: 5px!important;
        padding: 12px 20px!important;
        font-size: 12px!important;
        line-height: 84%!important;
        height: auto!important;
    }
    .notification_bar span {
        gap: 9px;
        flex-direction: column;
        text-align: center;
    }
    .total_btns {
        flex-direction: column;
        width: 100%;
    }
    .view_spec_btn, .download_spec, .metal_constr_select, .bottom_row_block {
        width: 100%;
    }
    .metal_constr_select {
        padding-right: 0px;
    }
    .bottom_row_block {
        flex-direction: column;
        gap: 20px;
    }
    .result_list {
        height: auto!important;
        overflow: auto!important;
    }
    .row_block {
        width: 100%;
    }
}

@media (max-width: 450px) {
    .modal_total {
        height: 655px;
        top: 350px;
    }
    .modal_total .modal_content {
        height: 355px;
    }
    .modal_total .modal_bottom__btns {
        flex-direction: column;
    }
    .modal_total .avr_summ_btn {
        width: 100%;
    }
    .modal_total .avr_excel_btn {
        width: 100%;
    }
}

@media (max-width: 400px) {
    .modal_total {
        height: 666px;
    }
}

@media (max-width: 390px) {
    .modal_total {
        width: 330px;
    }
}

@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .modal_total .modal_content {
        height: 370px;
    }
    .total_btns {
        justify-content: space-between;
        width: 100%;
    }
}

@media screen and (min-width: 1900px){
    .add_item_modal {
        width: auto;
    }
}

.notification_bar {
    width: auto;
    padding: 20px 25px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 63px;
    right: 125px;
    border-radius: 4px;
    background: #6C99FF;
    box-shadow: -2px 4px 16px 0px rgba(0, 0, 0, 0.15);
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    z-index: 999;
}

.notification_bar.error {
    background: #ff5757;
}

.notification_bar.error svg path {
    fill: #FFFFFF;
}

.notification_bar span {
    display: flex;
    align-items: center;
    gap: 10px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

tr.errors {
    border: 2px solid red;
}
.custom_select {
    position: relative;
}
.custom_select_dropdown {
    position: absolute;
    top: 33px;
    left: 0;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #CED4DA;
    background: #FFF;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.10);
    z-index: 2;
    padding: 0;
    width: 100%;
    max-height: 300px;
    overflow: auto;
}

.custom_select_dropdown li {
    list-style: none;
    border-top: 1px solid #CED4DA;
}

.custom_select_children:hover, .custom_select_row:hover {
    background: #E9F4FF;
    cursor: pointer;
}

.custom_select_children.active {
    background: #E9F4FF;
    cursor: pointer;
}

.custom_select_children input {
    display: none;
}

.custom_select_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 8px 8px 10px;
}

.custom_select_row input {
    display: none;
}

.custom_select_children {
    padding: 8px 8px 8px 25px;
    border-top: 1px solid #CED4DA;
}

.custom_select_childrens {
    padding: 0;
    display: flex;
    flex-direction: column;
}

.custom_select {
    cursor: pointer;
}

.d-none {
    display: none;
}

.select_item_btn {
    display: flex;
    width: 79px;
    height: 27px;
    padding: 3px 6px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: var(--Systemblue, #356EEF);
    color: var(--SystemWhite, #FFF);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

select:disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

input:disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

.top_panel {
    display: flex;
    gap: 10px;
    margin-top: 30px;
    align-items: center;
}
.tabs {
    display: flex;
    align-items: center;
    overflow: auto;
}
.content_tab {
    border-bottom: 2px solid var(--border-border-subtle-01, #C6C6C6);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 11px 16px;
    color: var(--text-text-secondary, var(--text-text-secondary, #525252));
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.16px;
}
.content_tab.active {
    border-bottom: 2px solid var(--border-border-interactive, #0F62FE);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
}
.content_tab-item {
    color: var(--text-text-primary, var(--text-text-primary, #161616));
    font-weight: 600;
}
.tab_content_item_form_input_label {
    display: block;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 8px;
}
.project_name_subtitle {
    color: #525252;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 20px;
}
.project_name {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 12px;
}
.input_row {
    display: flex;
    align-items: center;
    gap: 8px;
}
.input_groups {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.graphic_block.input_groups {
    justify-content: left;
    gap: 40px;
}
.tab_content {
    display: flex;
    gap: 25px;
    margin-top: 20px;
}
.tab_content_item {
    width: 100%;
    border-radius: 8px;
    background: rgba(217, 217, 217, 0.10);
    padding: 16px;
}
.tab_content_item.left .input_groups {
    align-items: baseline;
}
.graphic_info_title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.2px;
    display: flex;
    gap: 5px;
    align-items: center;
}
.graphic_info_title a{
    display: flex;
}
.graphic_info_title_bold {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19.2px;
}
.graphic_info_row .graphic_info_title {
    margin-bottom: 1rem;
}
.graphic_info_row {
    display: flex;
    gap: 20px; 
    justify-content: space-between;
}
.graphic_info {
    border-bottom: 1px solid #D9D9D9;
    margin-bottom: 10px;
}
.graphic_block {
    padding-bottom: 28px;
    border-bottom: 1px solid #D9D9D9;
    margin-bottom: 10px;
}
.row_block {
    position: relative;
}
.warning_text {
    display: block;
    position: absolute;
    bottom: 0px;
    color: #B70D09;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
}
.warning_text.var10 {
    bottom: auto;
}
.graphic_info_title_bold.warning {
    border-radius: 4px;
    background: #F1A5A3;
    padding: 4px 12px;
    height: 100%;
}
.result_list {
    height: 185px;
    overflow: auto;
}
.edit_title_container {
    display: flex;
    gap: 10px;
}
.edit_title_container_btns {
    display: flex;
    gap: 10px; 
}
.edit_title_input {
    border-radius: 4px;
    border: 1px solid #356EEF;
    width: 350px;
    padding: 0px 6px;
    height: 30px;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.save_title_btn {
    width: 85px;
    height: 30px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}
.cancel_title_btn {
    width: 85px;
    height: 30px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}
.title_edited {
    width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.title_edited:hover {
    border-radius: 4px;
    background: #F5F6F8;
}
.project_name_editable {
    cursor: pointer;
}
.delete_icon {
    display: flex;
}
.content_tab span {
    max-width: 115px;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 1.2em;
    text-wrap: nowrap;
}

.form_input.var10:disabled {
    filter: opacity(1);
}

.var10.warning {
    border: 1px solid red;
}

.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.modal_confirm_content {
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28.8px;
    margin-bottom: 30px;
}
.modal_confirm .modal_header {
    border: none;
}
.contact {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
}
.contact p {
    margin: 0px;
}
.summ_btn {
    margin-top: 24px;
}
</style>
